import { useGetSettingQuery } from "../../../../Redux/Apis/siteApi";

function Team() {
    const {data : {about: {team : {data,name,caption}}}} = useGetSettingQuery()

    return ( 
        <div className="mt-150">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 offset-lg-2 text-center">
                        <div className="section-title">
                            {name && <h3>{name.split(" ")[0]} <span className="orange-text">{name.split(" ").slice(1).join(" ")}</span></h3>}
                            {caption && <p>{caption}</p>}
                        </div>
                    </div>
                </div>
                <div className="row">
                    {data.lso_team && data.lso_team.map((row,index) => 
                    <div className="col-lg-4 col-md-6" key={index}>
                        <div className="single-team-item">
                            <div className="team-bg" style={{backgroundImage: `url(${row.img_image})`}}></div>
                            <h4>{row.txt_name} <span>{row.txt_career}</span></h4>
                            <ul className="social-link-team">
                                <li><a href={`https://facebook.com/${row.txt_facebook}`} target="_blank" rel="noreferrer"><i className="fab fa-facebook-f"></i></a></li>
                                <li><a href={`https://twitter.com/${row.txt_twitter}`} target="_blank" rel="noreferrer"><i className="fab fa-twitter"></i></a></li>
                                <li><a href={`https://instagram.com/${row.txt_instagram}`} target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a></li>
                            </ul>
                        </div>
                    </div>)}
                </div>
            </div>
        </div>
    );
}

export default Team;